import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { CreateUserInput, UserDetail } from "./types";
import { USERS_LIST_QUERY_KEY } from "./constants";

async function createUser(input: CreateUserInput): Promise<UserDetail> {
  return httpClient<UserDetail>("/api/admin/users", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });
}

export function useCreateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: USERS_LIST_QUERY_KEY });
    },
  });
}
